import { IconButton, Tooltip } from "@mui/material";
import { ReactNode, createElement } from "react";
import { IconType } from "react-icons/lib";

export type FilterButtonProps = {
    tooltip: ReactNode;
    icon: IconType;
    handleClick: (event: React.MouseEvent<HTMLElement>) => void;
    active?: boolean;
    disabled?: boolean;
};
function FilterButton({ icon, handleClick, tooltip, active, disabled = false }: FilterButtonProps) {
    return (
        <Tooltip title={tooltip}>
            <div>
                <IconButton
                    color={active ? "primary" : "secondary"}
                    onClick={(e) => handleClick(e)}
                    disabled={disabled}
                >
                    {createElement(icon)}
                </IconButton>
            </div>
        </Tooltip>
    );
}

export default FilterButton;
